export var SurveyJourneyStage;
(function (SurveyJourneyStage) {
    SurveyJourneyStage["ARRIVAL_CHECK_IN"] = "ARRIVAL_CHECK_IN";
    SurveyJourneyStage["ROOM_SLEEP"] = "ROOM_SLEEP";
    SurveyJourneyStage["FOOD_DRINK"] = "FOOD_DRINK";
    SurveyJourneyStage["SPA_WELLNESS"] = "SPA_WELLNESS";
    SurveyJourneyStage["SERVICE_STAFF"] = "SERVICE_STAFF";
    SurveyJourneyStage["VALUE_PRICE"] = "VALUE_PRICE";
    SurveyJourneyStage["GENERAL"] = "GENERAL";
})(SurveyJourneyStage || (SurveyJourneyStage = {}));
